import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Divider, Grid, Link, Typography, makeStyles } from '@material-ui/core';
import ReactTimeAgo from 'react-time-ago';
import { useDispatch } from 'react-redux';
import i18next from 'i18next';
import { useMutation, useQueryClient } from 'react-query';

import { addAlert } from '../../../actions/alerts.action';
import { deleteComment } from '../../../api/managerialDecision/managerialDecisionComment.api';
import Update from './Update';

const CommenttItem = ({ comment, managerialDecisionId }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const {
    content,
    commenter_name,
    created_at,
    edited_at,
    isEditable
  } = comment;

  const lng = i18next.languages[0];
  const [ isEditing, setIsEditing ] = useState(false);

  const deleteCommentMutation = useMutation(
    async () => {
      return await deleteComment({ managerialDecisionId, commentId: comment?.id });
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([ 'managerialDecisionComments', managerialDecisionId ]);
      },
      onError: error => {
        dispatch(addAlert({ message: error.message, severity: 'error' }));
      }
    }
  );

  const useStyles = makeStyles({
    comment: {
      margin: '8px 0',
      fontSize: '12px',
      color: '#666666',
      whiteSpace: 'pre-wrap'
    },
    info: {
      fontSize: '12px',
      color: '#999999',
      marginLeft: '10px'
    },
    button: {
      marginRight: '10px'
    }
  });

  const classes = useStyles();

  return (
    <>
      <Grid container direction={ 'column' }>
        <Grid item>
          <b>{ commenter_name }</b>
          <ReactTimeAgo
            className={ classes.info }
            date={ new Date(created_at) }
            locale={ lng }
          />
          { edited_at !== null &&
            <>
              <span className={ classes.info }>
                |
              </span>
              <span className={ classes.info }>
                { t('managerialDecisionComments.edited') }
              </span>

            </>
          }
        </Grid>
        <Grid item className={ classes.comment }>
          { isEditing ? (
            <Update
              comment={ comment }
              setIsEditing={ setIsEditing }
              managerialDecisionId={ managerialDecisionId }
            />
          ) : (
            <Typography variant='body1'>
              { content }
            </Typography>
          )}
        </Grid>
        { isEditable && !isEditing &&
          <Grid>
            <Grid item>
              <Link
                onClick={ () => setIsEditing(true) }
                color='inherit'
                variant='body2'
                className={ classes.button }
              >
                {t('managerialDecisionComments.update')}
              </Link>
              <Link
                onClick={ deleteCommentMutation.mutate }
                color='inherit'
                variant='body2'
                className={ classes.button }
              >
                {t('managerialDecisionComments.delete')}
              </Link>
            </Grid>
          </Grid>
        }
      </Grid>
      <Divider style={ { margin: '10px auto' } }/>
    </>
  );
};

export default CommenttItem;
